import {createStore} from "vuex";
import {
    handleGetAllRouter,
    handleGetAllRouters,
    routerRun,
} from "@/router/allRoutes";
import {login} from "@/api/login";
import {GetAuthorityList} from "@/api/Entrust";
import {GetUserRole} from "@/api/Authority";
import {DEFAULTCARFORMDATA} from "@/data";
import {clone} from "lodash";
import {findCarInformation} from "@/api/V2";
import router from "@/router";

export default createStore({
    state: {
        leftMenu: [], // 路由
        curentLeftMenu: {}, // 当前左侧菜单
        BreadList: [], // 面包屑
        roleList: localStorage.getItem("roleList")
            ? JSON.parse(localStorage.getItem("roleList"))
            : [], // 角色列表
        // 从缓存里拿取 数据 没有则[]
        ruleList: [], // 权限列表
        filteredRoutes: [], // 过滤后的路由
        // newRouteschildrenrouter: [] //最新路由
        isRouter: false,
        // 20240731
        /**
         * 任务流信息 持续优化TODO
         */
        carFormData: clone(DEFAULTCARFORMDATA),
        // 流程数据
        flowData: {},
        // 审批数据存储
        approvalData: [],
        // 照片是否可以上传
        isPhotoUpload: false,
        // 保全后面就不可以对图片进行操作了
        isPhotoUploadEnd: false,
        // 整体最外层的按钮是否显示
        allDisableBtn: false,
        /**
         * 照片是否可编辑
         */
        carPicStatus: {
            IS_DISABLED_TRAILER: false, // 拖车照片
            IS_DISABLED_CHARGES: false, // 费用照片
            IS_DISABLED_PROCEDURES: false, // 手续照片
            IS_DISABLED_CAR: false, // 车辆照片
            IS_DISABLED_PAYMENT: false, // 交款提车
            IS_DISABLED_TRANSFER: false, // 过户照片
            IS_DISABLED_APPROVAL: false, // 审批流程
        },

        // 菜单
        menus: [],
        // 路由
        routers: [],
        // 路由key 对应顶级菜单 的映射
        router2menu: {},
        btns: [],
    },
    getters: {
        //获取本地路由信息
        newRouteschildrenrouter(state) {
            const allRoutes = handleGetAllRouter();
            const list = state.roleList.map((e) => {
                return e.routerPath;
            });
            console.log(allRoutes, "------3333--------");

            // 第一层路由筛选
            const newRoutes = allRoutes.filter((route) => {
                return list.includes(route.path);
            });
            console.log(newRoutes, "newRoutes");
            // 第二层路由筛选
            // const newRouteschildren = newRoutes.filter(route => {
            //     route.children.filter(e => {

            //         list.includes(e.path);
            //     });
            // });
            // return allRoutes
            return newRoutes;
        },
        auths(state) {
            const menuKey = state.btns.map((item) => {
                return item.menuKey;
            });
            return menuKey;
        },
        // 返回carPicStatus
        carPicStatus(state) {
            return state.carPicStatus;
        },
    },
    mutations: {
        SET_ISROUTER(state, bool) {
            console.log(bool, "bool------ state.isRouter");
            state.isRouter = bool;
        },
        async editRoutes(state, allRoutes) {
            console.log(allRoutes, "allRoutes");
            // 用户可以看的路由
            const list = state.roleList.map((e) => {
                return e.routerPath;
            });

            // 第一层路由筛选
            const newRoutes = allRoutes.filter((route) => {
                return list.includes(route.path);
            });
            // 第二层路由筛选
            // const newRouteschildren = newRoutes.filter(route => {
            //     return route.children.filter(e => {
            //         return list.includes(e.path);
            //     });
            // });
            // state.newRouteschildrenrouter = allRoutes
            state.newRouteschildrenrouter = newRoutes;
            // 更新路由
            // state.newRouteschildrenrouter = newRouteschildren
        },
        filterLeftMenu(state) {
            // 遍历 leftMenu 中的每个菜单项
            state.leftMenu.forEach((leftMenu) => {
                // 如果 leftMenu 中的菜单项的 Path 与 roleList 中的菜单项的 routerPath 相同
                // if (state.leftMenu.Path === state.roleList.routerPath) {
                // 将 leftMenu 中的菜单项添加到过滤后的路由数组中
                state.filteredRoutes.push(leftMenu);
                // }
            });

            // 更新 filteredRoutes 状态
            state.filteredRoutes = filteredRoutes;
        },
        setRoleList(state, menu) {
            state.roleList = menu;
            localStorage.setItem("roleList", JSON.stringify(menu));

            // console.log(state.roleList, '我已经存在');
        },
        setRuleList(state, menu) {
            state.ruleList = menu;
        },
        setLeftMenu(state, menu) {
            state.leftMenu = menu;
        },
        setBreadList(state, menu) {
            state.BreadList = menu;
        },
        clearLeftMenu(state) {
            state.leftMenu = [];
        },
        setIsPhotoUpload(state, menu) {
            console.log(menu, "menumenumenumenu");

            state.isPhotoUpload = menu;
        },
        SetIsPhotoUploadEnd(state, menu) {
            state.isPhotoUploadEnd = menu;
        },
        SetAllDisableBtn(state, menu) {
            state.allDisableBtn = menu;
        },
        // 修改照片是否可编辑
        SET_IS_DISABLED_EDIT(state, payload) {
            state.carPicStatus[payload.key] = payload.isDisabled;
        },
    },
    actions: {
        // state 加载 从缓存拿权限列表
        // 路由列表 是后来生成
        // 权限是否存在 存在 筛选 生成路由
        // 不存在 获取接口 保存权限列表到缓存 生成路由

        updateFilteredRoutes({commit}, roleList) {
            commit("filterLeftMenu", roleList);
        },
        // ------------------------------------------------------
        /**
         * 登录
         */
        async handleLogin(store, data) {
            let res = await login(data);
            if (res.success) {
                console.log(res.entity);
                // # Rewiew 可以判res 没必要在这里存了再拿 用作判断
                sessionStorage.setItem("token", res.entity.token);
                localStorage.setItem("user", JSON.stringify(res.entity));
                let s = await store.dispatch("handleGetRole");
                if (s === '') {
                    res.success = false;
                    res.message = "未获取到用户权限";
                }
            }
            return res;
        },
        /**
         * 获取角色权限 菜单权限
         */
        async handleGetRole(store) {
            let res = await GetAuthorityList();
            if (res.code == 200) {
                if (res.entity.roleList == null || res.entity.roleList.length === 0) {
                    sessionStorage.removeItem("token");
                    localStorage.removeItem("user");
                    localStorage.clear();
                    router.push("/login");
                    return "";
                }
                store.commit("setRoleList", res.entity.roleList[0].menus);
                store.commit("setRuleList", res.entity.ruleList);
                store.commit("editRoutes", handleGetAllRouter());
                const {menus, routers, router2menu, btns} = await routerRun(
                    res.entity.roleList
                );
                store.state.menus = menus;
                store.state.routers = routers;
                store.state.router2menu = router2menu;
                store.state.btns = btns;
            } else {
                sessionStorage.removeItem("token");
                localStorage.removeItem("user");
                localStorage.clear();
                router.push("/login");
            }
            let res2 = await GetUserRole({
                userId: JSON.parse(localStorage.getItem("user")).id,
            });
            if (res2.success) {
                console.log("res2.entityList-------------------");

                localStorage.setItem("userRole", JSON.stringify(res2.entityList));
            }
            return "success";
        },
        // 存储审批数据
        setApprovalData({state}, data = {}) {
            state.approvalData = data;
        },

        /**
         * 设置任务流表单
         */
        setCarFormData({state}, data = {}) {
            state.carFormData = data;
            console.log( JSON.stringify(data), "setCarFormData 给store的carformdata赋值");
        },
        restCarFormData({state}) {
            state.carFormData = DEFAULTCARFORMDATA;
        },
        /**
         * 获取车信息
         */
        async handleGetCarInfo({state}, data) {
            // 调取mutations中的SETFLOWDATA
            if (data) {
                state.flowData = data;
            }
            if (!data.carId) {
                console.error("请传入车id");
                return;
            }

            let res = await findCarInformation({
                carId: data.carId || data.id,
            });
            if (res.code == 200) {
                state.carFormData = {
                    ...res.entity,
                    carId: data.carId || data.id,
                };
            }
        },
    },
});
